import { Link } from "react-router-dom";
import "./Home.css";
import gameIcon from "../assets/game-icon.png"; // your game icon

export default function Home() {
  return (
    <div className="home">
      <video autoPlay muted loop playsInline className="bg-video">
        <source src="/gameplay.mp4" type="video/mp4" />
      </video>

      <div className="overlay">
        <div className="title-container">
          <img src={gameIcon} alt="StickBox" className="game-icon" />
          <h1 className="title">
            <span className="title-red">Stick</span>
            <span className="title-white">Box</span>
        </h1>
        </div>
        <p className="subtitle">Kill, parkour, create, have fun!</p>

        <div className="store-buttons">
          <a
            href="https://play.google.com/store/apps/details?id=com.stickman.killer.backflip"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/google-play-badge.png"
              alt="Get it on Google Play"
              className="store-badge"
            />
          </a>
          <a
            href="https://apps.apple.com/app/id6755522809"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/app-store-badge.svg"
              alt="Download on the App Store"
              className="store-badge"
            />
          </a>
        </div>
      </div>

      <footer>
        <Link to="/terms">Terms of Service</Link> |{" "}
        <Link to="/privacy">Privacy Policy</Link>
      </footer>
    </div>
  );
}
